import { Table, Tooltip } from "antd";
import clsx from "clsx";
import React, { memo, useLayoutEffect, useRef } from "react";
import { OverlayTrigger } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import IDXDetailChart from "./index-components/IDXDetailChart";
import { formatNumber, formatNumberToB, formatNumberToM, formatPctChangePrice, formatQtty, isNullOrEmpty, priceToNumber } from "../helpers/utils";
import { constMarketCode } from "../helpers/constData";
import IDXSumary from "./index-components/IDXSumary";

export default function PriceBoard_Plasma(props) {
   const { tabName, marketCode, indexCode, industryCode, isOddLot, underlying, favListid } = props;
   const { t } = useTranslation();
   const priceBoardIndexMode = useSelector((state) => state.gShared.priceBoardIndexMode);
   const numberOfStockCode = 5;

   const headerIndexes = ["VNINDEX", "VN30", "HNXINDEX", "HNX30"];
   const allIndexInfos = useSelector((state) => state.gIndex.indexInfos);
   const indexInfo = headerIndexes.map((code) => {
      return allIndexInfos.find((el) => el.indexCode === code) ?? {};
   });

   const { symbolInfos: storedSymbolInfos } = useSelector(
      (state) => ({
         symbolInfos: state.gSymbol.symbolInfos,
      }),
      (prev, next) => {
         return prev.symbolInfos?.length === next.symbolInfos?.length;
      }
   );

   const serverTime = useSelector((state) => state.gShared.serverTime);
   const serverDate = serverTime > 0 ? new Date(serverTime) : new Date();
   //
   const top5_HSX = storedSymbolInfos
      .filter((e) => e.marketCode === constMarketCode.HSX && priceToNumber(e.totalTradedQttyNM) > 0)
      .sort((a, b) => priceToNumber(b.totalTradedQttyNM) - priceToNumber(a.totalTradedQttyNM) || a.code.localeCompare(b.code))
      .slice(0, numberOfStockCode);
   const top5_HNX = storedSymbolInfos
      .filter((e) => e.marketCode === constMarketCode.HNX && priceToNumber(e.totalTradedQttyNM) > 0)
      .sort((a, b) => priceToNumber(b.totalTradedQttyNM) - priceToNumber(a.totalTradedQttyNM) || a.code.localeCompare(b.code))
      .slice(0, numberOfStockCode);

   return (
      <div className="main-plasma">
         <div className="header-plasma">
            <div></div>
            {/* <div className="left-header"> */}
            <div className="logo-plasma">
               <img src="/static/img/logo_tvsi_2.svg" alt="logo" />
            </div>
            {/* <div className="left-title">
                  CHỨNG KHOÁN TÂN VIỆT <span>Sàn giao dịch của mọi nhà</span>
               </div> */}
            <div></div>
            <p>{t("thongKeThiTruong")}</p>
            <div className="timeline__now">{serverDate.toLocaleTimeString("en-GB")}</div>
         </div>
         <div className="body-plasma">
            <div className="body-1">
               <div className="column">
                  <div className="row-p">
                     VN-INDEX
                     <span className={indexInfo[0].currentIndex_color}>{formatNumber(indexInfo[0].currentIndex)}</span>
                  </div>
                  <div className="row-p">
                     {t("soLenhKhop")}
                     <span className="text-white">{"--"}</span>
                  </div>
                  <div className="row-p">
                     VN30
                     <span className={indexInfo[1].currentIndex_color}>{formatNumber(indexInfo[1].currentIndex)}</span>
                  </div>
               </div>
               <div className="column">
                  <div className="row-p">
                     {t("thayDoi")}
                     <span className={indexInfo[0].changeIndex_color}>{formatNumber(indexInfo[0].changeIndex)}</span>
                  </div>
                  <div className="row-p">
                     {t("kl")}:<span className="text-white">{formatNumber(indexInfo[0].totalTradedQtty)}</span>
                  </div>
                  <div className="row-p">
                     {t("thayDoi")}
                     <span className={indexInfo[1].changeIndex_color}>{formatNumber(indexInfo[1].changeIndex)}</span>
                  </div>
               </div>
               <div className="column">
                  <div className="row-p">
                     (%) {t("thayDoi")}
                     <span className={indexInfo[0].pctChangeIndex_color}>{formatNumber(indexInfo[0].pctChangeIndex)}</span>
                  </div>
                  <div className="row-p">
                     {t("gt")} ({t("ty")}):<span className="text-white">{formatNumberToB(indexInfo[0].totalTradedValue)}</span>
                  </div>
                  <div className="row-p">
                     (%) {t("thayDoi")}
                     <span className={indexInfo[1].pctChangeIndex_color}>{formatNumber(indexInfo[1].pctChangeIndex)}</span>
                  </div>
               </div>
               <div className="column-1">
                  <div className="row-1">
                     <img src="/static/img/icon/icon-gr-up.svg" alt="img" />
                     &nbsp;
                     {indexInfo[0].up}
                  </div>
                  <div className="row-1">
                     {" "}
                     <img src="/static/img/icon/icon-bl-yl.svg" alt="img" /> &nbsp;
                     {indexInfo[0].noChange}
                  </div>
                  <div className="row-1">
                     <img src="/static/img/icon/icon-down.svg" alt="img" /> &nbsp;
                     {indexInfo[0].down}
                  </div>
               </div>
               <div className="column">
                  <div className="row-p">
                     {t("trangThai")}
                     <span className="text-white"> {t("indexStatus_" + indexInfo[0].status)} </span>
                  </div>
               </div>
            </div>
            <div className="body-2">
               <div className={clsx("boxchart__grid", priceBoardIndexMode && priceBoardIndexMode === "FULL" ? "" : "hidden")} style={{ position: "relative" }}>
                  <OverlayTrigger
                     placement="bottom"
                     overlay={
                        <Tooltip style={{ opacity: 1 }}>
                           <p>
                              <span className="text-left"> {t("thap")}: </span>
                              <span className={clsx("text-right", indexInfo[0].lowestIndex_color)}>{formatNumber(indexInfo[0].lowestIndex)}</span>
                              <span className="text-left"> {t("cao")}: </span>
                              <span className={clsx("text-right", indexInfo[0].highestIndex_color)}>{formatNumber(indexInfo[0].highestIndex)}</span>
                           </p>
                        </Tooltip>
                     }
                  >
                     <div className="boxchart__grid__float" style={{ fontSize: 11, lineHeight: "11px", position: "absolute", top: 5, right: 6, zIndex: 1 }}></div>
                  </OverlayTrigger>
                  <React.Suspense fallback={<p>Loading...</p>}>
                     <IDXDetailChart style={{ height: "100%", width: "100%" }} indexCode={indexInfo[0].indexCode} priorIndex={priceToNumber(indexInfo[0].priorIndex)} />
                  </React.Suspense>
               </div>
               <div className="top-5-price">
                  <h3>TOP 5 GD</h3>
                  <table className="custom-plasma-table">
                     <thead>
                        <th>{t("maCK")} </th>
                        <th>{t("tongKL")}</th>
                        <th>{t("gia")}</th>
                        <th>+/-</th>
                        <th>{t("kl")}</th>
                     </thead>
                     <tbody>
                        {top5_HSX.length > 0 &&
                           top5_HSX.map((item, index) => (
                              <tr key={index}>
                                 <td className={item?.matchPrice_color}>{item?.code}</td>
                                 <td>
                                    <CellRenderer cellParams={item} fieldProps={"totalTradedQttyNM"} value={item?.totalTradedQttyNM} isQtty={true} />
                                 </td>
                                 <td>
                                    <CellRenderer cellParams={item} fieldProps={"matchPrice"} value={item?.matchPrice} colorClass={item?.matchPrice_color} />
                                 </td>
                                 <td>
                                    <CellRenderer cellParams={item} fieldProps={"changePrice"} value={item?.changePrice} colorClass={item?.changePrice_color} />
                                 </td>
                                 <td>
                                    <CellRenderer cellParams={item} fieldProps={"matchQtty"} value={item?.matchQtty} colorClass={item?.matchQtty_color} isQtty={true} />
                                 </td>
                              </tr>
                           ))}
                     </tbody>
                  </table>
               </div>
            </div>
            <div className="body-1">
               <div className="column">
                  <div className="row-p">
                     HNX-INDEX
                     <span className={indexInfo[2].currentIndex_color}>{formatNumber(indexInfo[2].currentIndex)}</span>
                  </div>
                  <div className="row-p">
                     {t("soLenhKhop")}
                     <span className="text-white">{"--"}</span>
                  </div>
                  <div className="row-p">
                     HNX30
                     <span className={indexInfo[3].currentIndex_color}>{formatNumber(indexInfo[3].currentIndex)}</span>
                  </div>
               </div>
               <div className="column">
                  <div className="row-p">
                     {t("thayDoi")}
                     <span className={indexInfo[2].changeIndex_color}>{formatNumber(indexInfo[2].changeIndex)}</span>
                  </div>
                  <div className="row-p">
                     {t("kl")}:<span className="text-white">{formatNumber(indexInfo[2].totalTradedQtty)}</span>
                  </div>
                  <div className="row-p">
                     {t("thayDoi")}
                     <span className={indexInfo[3].changeIndex_color}>{formatNumber(indexInfo[3].changeIndex)}</span>
                  </div>
               </div>
               <div className="column">
                  <div className="row-p">
                     (%) {t("thayDoi")}
                     <span className={indexInfo[2].pctChangeIndex_color}>{formatNumber(indexInfo[2].pctChangeIndex)}</span>
                  </div>
                  <div className="row-p">
                     {t("gt")} ({t("ty")}):<span className="text-white">{formatNumberToB(indexInfo[2].totalTradedValue)}</span>
                  </div>
                  <div className="row-p">
                     (%) {t("thayDoi")}
                     <span className={indexInfo[3].pctChangeIndex_color}>{formatNumber(indexInfo[3].pctChangeIndex)}</span>
                  </div>
               </div>
               <div className="column-1">
                  <div className="row-1">
                     <img src="/static/img/icon/icon-gr-up.svg" alt="img" />
                     &nbsp;
                     {indexInfo[2].up}
                  </div>
                  <div className="row-1">
                     {" "}
                     <img src="/static/img/icon/icon-bl-yl.svg" alt="img" /> &nbsp;
                     {indexInfo[2].noChange}
                  </div>
                  <div className="row-1">
                     <img src="/static/img/icon/icon-down.svg" alt="img" /> &nbsp;
                     {indexInfo[2].down}
                  </div>
               </div>
               <div className="column">
                  <div className="row-p">
                     {t("trangThai")}
                     <span className="text-white"> {t("indexStatus_" + indexInfo[2].status)} </span>
                  </div>
               </div>
            </div>
            <div className="body-2">
               <div className={clsx("boxchart__grid", priceBoardIndexMode && priceBoardIndexMode === "FULL" ? "" : "hidden")} style={{ position: "relative" }}>
                  <OverlayTrigger
                     placement="bottom"
                     overlay={
                        <Tooltip style={{ opacity: 1 }}>
                           <p>
                              <span className="text-left"> {t("thap")}: </span>
                              <span className={clsx("text-right", indexInfo[2].lowestIndex_color)}>{formatNumber(indexInfo[2].lowestIndex)}</span>
                              <span className="text-left"> {t("cao")}: </span>
                              <span className={clsx("text-right", indexInfo[2].highestIndex_color)}>{formatNumber(indexInfo[2].highestIndex)}</span>
                           </p>
                        </Tooltip>
                     }
                  >
                     <div className="boxchart__grid__float" style={{ fontSize: 11, lineHeight: "11px", position: "absolute", top: 5, right: 6, zIndex: 1 }}></div>
                  </OverlayTrigger>
                  <React.Suspense fallback={<p>Loading...</p>}>
                     <IDXDetailChart style={{ height: "100%", width: "100%" }} indexCode={indexInfo[2].indexCode} priorIndex={priceToNumber(indexInfo[2].priorIndex)} />
                  </React.Suspense>
               </div>
               <div className="top-5-price">
                  <h3>TOP 5 GD</h3>
                  <table className="custom-plasma-table">
                     <thead>
                        <th>{t("maCK")} </th>
                        <th>{t("tongKL")}</th>
                        <th>{t("gia")}</th>
                        <th>+/-</th>
                        <th>{t("kl")}</th>
                     </thead>
                     <tbody>
                        {top5_HNX.length > 0 &&
                           top5_HNX.map((item, index) => (
                              <tr key={index}>
                                 <td className={item?.matchPrice_color}>{item?.code}</td>
                                 <td>
                                    <CellRenderer cellParams={item} fieldProps={"totalTradedQttyNM"} value={item?.totalTradedQttyNM} isQtty={true} />
                                 </td>
                                 <td>
                                    <CellRenderer cellParams={item} fieldProps={"matchPrice"} value={item?.matchPrice} colorClass={item?.matchPrice_color} />
                                 </td>
                                 <td>
                                    <CellRenderer cellParams={item} fieldProps={"changePrice"} value={item?.changePrice} colorClass={item?.changePrice_color} />
                                 </td>
                                 <td>
                                    <CellRenderer cellParams={item} fieldProps={"matchQtty"} value={item?.matchQtty} colorClass={item?.matchQtty_color} isQtty={true} />
                                 </td>
                              </tr>
                           ))}
                     </tbody>
                  </table>
               </div>
            </div>
         </div>
         <div className="footer-plasma"></div>
      </div>
   );
}
const CellRenderer = memo(
   function (props) {
      const { cellParams, fieldProps, value, colorClass, isQtty } = props;
      const code = cellParams.code;
      const field = fieldProps;

      const tagId = code + "_" + field;
      const prevValue = useRef(value);

      const fieldInfo = {
         value: value ?? "",
         colorClass: colorClass ?? "",
      };

      let displayValue = fieldInfo?.value ?? "";
      if (isQtty) {
         displayValue = formatQtty(fieldInfo?.value ?? "");
      } else if (field == "totalTradedValueNM") {
         displayValue = formatNumberToM(fieldInfo?.value ?? "");
      } else if (field == "changePrice" || field == "pctChangePrice") {
         displayValue = formatPctChangePrice(fieldInfo?.value);
      }

      if (field == "pctChangePrice" && !isNullOrEmpty(displayValue)) {
         displayValue += "%";
      }

      //
      useLayoutEffect(() => {
         let _timerId = -1;
         const _el = document.getElementById(tagId).parentElement;

         if (prevValue.current !== value) {
            prevValue.current = value;
            if (_el) {
               _el.classList.remove("active_change");
               _el.classList.add("active_change");
               _timerId = setTimeout(() => {
                  _el.classList.remove("active_change");
               }, 300);
            }
         }

         return () => {
            clearTimeout(_timerId);
         };
      });
      //
      return (
         <span className={fieldInfo?.colorClass ?? ""} id={tagId}>
            {displayValue}
         </span>
      );
   },
   (prevProps, nextProps) => {
      if (prevProps.value === nextProps.value && prevProps.colorClass === nextProps.colorClass) {
         return true;
      }
      return false;
   }
);
